import { Box, BoxProps } from "@chakra-ui/react";

export function CheckIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="100%"
        height="29"
        viewBox="0 0 30 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="15"
          cy="14.5"
          r="13.5909"
          fill="#4285F4"
          stroke="#E4EBF0"
          stroke-width="1.18182"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.6095 18.5111L13.1081 18.0097L12.6067 18.5111C12.8836 18.788 13.3326 18.788 13.6095 18.5111ZM13.1081 17.0069L9.82768 13.7264C9.55076 13.4495 9.10179 13.4495 8.82488 13.7264C8.54796 14.0034 8.54796 14.4523 8.82488 14.7292L12.6067 18.5111L13.1081 18.0097C13.6095 18.5111 13.6095 18.5111 13.6095 18.5111L20.9061 11.2145C21.183 10.9376 21.183 10.4886 20.9061 10.2117C20.6291 9.93478 20.1802 9.93478 19.9033 10.2117L13.1081 17.0069Z"
          fill="white"
        />
      </svg>
    </Box>
  );
}
